export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'
// export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'ru']
export const AVAILABLE_LANGUAGES = {
    en: 'english',
    de: 'deutsch',
    fr: 'français',
    ru: 'русский'
}